import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { SystemService } from '../services/system.service';

@Injectable({
  providedIn: 'root'
})
export class ExcelFileService {

  constructor(private http: HttpClient, private system: SystemService) {}

  uploadFile(file: File, importType: string): Observable<number> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('import_type', importType);

    return this.http.post(this.system.apiURL + '/imports/upload', formData, {
      reportProgress: true,
      observe: 'events',
      headers: {
        'Accept': 'application/json' // Ensure JSON response expected
      }  
    }).pipe(
      map((event) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            return Math.round((100 * event.loaded) / (event.total || 1));
          case HttpEventType.Response:
            return 100; // Upload complete
          default:
            return 0; // Starting
        }
      })
    );
  }
}
